import type { IAnswerValue } from '@/interfaces'

class AnswerValue implements IAnswerValue {
  recordId: string

  creatorId: string

  updaterId: string

  value: string

  comment: string

  isChecked?: boolean

  constructor(answer: any) {
    this.recordId = answer.recordId
    this.creatorId = answer.creatorId
    this.updaterId = answer.updaterId
    this.value = answer.value
    this.comment = answer.comment

    if (answer.isChecked) {
      this.isChecked = answer.isChecked
    }
  }
}

export default AnswerValue
